import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { connect } from '../../redux/connect';
import { withRouter } from 'react-router-dom';
import * as ReportsThunk from '../../redux/thunk/reportsThunk';
import MaintenanceMode from '../../app/components/MaintenanceMode';

import {
  fetchIssuesAction,
  removeIssueFromCollectionAction,
  changeLocationAction,
  setQueryParamsAction,
  trackEvent,
  setPreviewIssueIdAction,
} from '../../redux/actions';
import {
  getIssueWrappersSorted,
  getIssuesCollectionLoading,
  getIssuesCollectionError,
  getIssuesCollectionPagiantion,
  getCurrentPreviewIssueId,
  isShowNewIssueModal,
  getCurrentUser,
  getIssuesOrder,
  getIsCreatingPdfReport,
  getQueryParams,
  getFetchParams,
  getCurrentPreviewIssueAttributes,
  isVoidedFilterOn,
  isCostEnabled,
  isMeetingEnabled,
} from '../../redux/selectors';


import { userType, issueWrapperArrayType, paginationPropType, issuesSortOrderArrayType, issuesFetchParamsType, issueAttributesType, pendingIssueFormAttributesType } from '../../constants/proptype-validation';
import IssueFetchError from '../../components/IssueFetchError';
import ProjectList from './components/ProjectList';
import IssueNewModal from './components/IssueNewModal';
import IssuePreviewModal from '../../components/IssuePreviewModal';
import IssueAttachmentGallery from '../../components/IssueAttachmentGallery';
import { Button, Loader, TablePagination, EmptyState, ExportPDFModal, IFrameModal, Text } from '@adsk/bim360-matrix-react-components';
import { canAdd } from '../../utils/issues-helpers';
import { getScrollableParent } from '../../utils/html-helpers';
import { getRfiSummaryPayload } from '../../utils/reportHelpers';
import { toIsoDate } from '../../utils/date-helpers';
import { parseQueryString, stripSearchQuery } from '../../utils/query-helpers';
import T from 'i18n-react';
import { get as lodashGet, values as objectValues, pick } from 'lodash';
import { POPUP_VIEWER_URL, POPUP_VIEWER_TITLE } from '../../constants/common';
import { STATUS_VOID } from '../../constants/status-types';
import { screenType } from '../../constants/analytics';
import { entityIssueScreen } from '../../utils/analytics-helpers';
import { ISSUE_FILTER_PROPERTIES, PAGE_PARAMS } from '../../constants/issue-query-params';
import ProjectGridHeader from './components/ProjectGridHeader';
import NoPermissionsModal from './components/NoPermissionsModal';
import featureFlags, { FEATURE_FLAGS } from '../../utils/featureFlags';
import { preloadedFilterQueryParamsState } from '../../constants/preloaded-states';
import Filter from '../../components/Filter';
import DrawerWrapper from "./components/DrawerWrapper";
import { viewTypes } from "../../constants/view-types";
import pco from '@adsk/bim360-matrix-react-components/es/plugins/pco';
import meeting from '@adsk/bim360-matrix-react-components/es/plugins/meeting-item';
import issue from '@adsk/bim360-matrix-react-components/es/plugins/issue';
import LinkedEntitiesProviderFF from './components/LinkedEntitiesProviderFF';

export class PureProjectGrid extends PureComponent {

  static displayName = 'ProjectGrid';

  static propTypes = {
    issues: issueWrapperArrayType.isRequired,
    issue: PropTypes.oneOfType([PropTypes.object, issueAttributesType, pendingIssueFormAttributesType]),
    loading: PropTypes.bool.isRequired,
    pagination: paginationPropType,
    issueId: PropTypes.string,
    showAddNewModal: PropTypes.bool,
    error: PropTypes.bool,
    currentUser: userType,
    issuesSortOrder: issuesSortOrderArrayType,
    changeLocationAction: PropTypes.func.isRequired,
    setQueryParamsAction: PropTypes.func.isRequired,
    createReport: PropTypes.func.isRequired,
    isCreatingPdfReport: PropTypes.bool,
    queryParams: PropTypes.object,
    fetchParams: issuesFetchParamsType.isRequired,
    fetchIssuesAction: PropTypes.func.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.object,
    trackEvent: PropTypes.func,
    setPreviewIssueIdAction: PropTypes.func.isRequired,
    removeIssueFromCollectionAction: PropTypes.func.isRequired,
    isVoidedFilterOn: PropTypes.bool,
    isCostEnabled: PropTypes.bool,
    isMeetingEnabled: PropTypes.bool,
  };

  constructor(props) {
    super(props);
    this.state = {
      isTableHeaderFixed: false,
      isPaginationFooterFixed: false,
      didFetchOnce: false,
      showExportPdfModal: false,
      searchExpression: "",
      filtersOpen: false,
    };

    this._canUserAddIssue = null;

    this.handlePageScroll = this.handlePageScroll.bind(this);
    this.closePreviewModal = this.closePreviewModal.bind(this);
    this.updateSearchExpression = this.updateSearchExpression.bind(this);
    this.showExportPdfModal = this.showExportPdfModal.bind(this);
    this.changeIssueDetailsModalId = this.changeIssueDetailsModalId.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.returnToListView = this.returnToListView.bind(this);
    this.setIsFilterOpen = this.setIsFilterOpen.bind(this);
  }

  componentWillMount() {
    this._initializeCurrentUserPermissions(this.props);

    //MixPanel Event - when user watch issue screen and what screen is it (Project/document)
    this.props.trackEvent(entityIssueScreen(screenType.PROJECT));
  }

  componentDidMount() {
    window.addEventListener('resize', this.handlePageScroll);
    if (this.props.queryParams.hasSetQueryParamsFromUrl) {
      this.props.fetchIssuesAction({ resetCollection: true });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.loading && !nextProps.loading && !this.state.didFetchOnce) {
      this.setState({ didFetchOnce: true });
    }

    if (nextProps.isCreatingPdfReport === false && this.props.isCreatingPdfReport === true) {
      this.setState({ showExportPdfModal: false });
    }

    //changeToStatus is an attribute that will be only if the issue got transited
    if (lodashGet(nextProps, 'issue.changeToStatus') === STATUS_VOID && !this.props.isVoidedFilterOn) {
      this.props.removeIssueFromCollectionAction(nextProps.issue.id);
    }

    if (!!this.props.issueId && !nextProps.issueId) {
      this.returnToListView();
    }
  }

  componentWillUpdate(nextProps) {
    if (nextProps.currentUser !== this.props.currentUser) {
      this._initializeCurrentUserPermissions(nextProps);
    }
  }

  componentDidUpdate(prevProps) {
    const { fetchParams, fetchIssuesAction, issues, loading } = this.props;
    // After we've fetched issues, find the first scrollable dom element and bind to it's scroll event (for hiding/showing sticky footer)
    // This is done in ComponentDidUpdate for making sure the Table is already rendered
    if (issues.length && !loading && !this.scrollableParent) {
      this.bindParentScrollEvent();
    }
    if (prevProps.fetchParams !== fetchParams) {
      fetchIssuesAction({ resetCollection: true });
    }
  }

  componentWillUnmount() {
    if (this.scrollableParent) {
      this.scrollableParent.removeEventListener('scroll', this.handlePageScroll);
    }
    window.removeEventListener('resize', this.handlePageScroll);
  }

  bindParentScrollEvent() {
    this.scrollableParent = getScrollableParent(this.containerNode);

    if (this.scrollableParent) {
      this.scrollableParent.addEventListener('scroll', this.handlePageScroll);
    }
  }

  updateFixedElementsWidth() {
    const tableRow = this.tableElement.querySelector('.Table__data-row');
    if (tableRow) {
      const rowWidth = tableRow.offsetWidth;
      const headerRow = this.tableElement.querySelector('.Table__header-row');
      if (headerRow) {
        headerRow.style.width = `${rowWidth}px`;
      }

      const tablePagination = this.containerNode.querySelector('.TablePagination');
      if (tablePagination) {
        tablePagination.style.width = `${rowWidth}px`;
      }
    }
  }

  closePreviewModal() {
    this.props.setPreviewIssueIdAction(null);
  }

  handlePageScroll() {
    if (this.scrollableParent && this.tableElement) {
      const TABLE_TOP_MINIMUM_MARGIN = 15;
      const currentScrollTop = this.scrollableParent.scrollTop;
      const pageClientRect = this.scrollableParent.getBoundingClientRect();
      const tableClientRect = this.tableElement.getBoundingClientRect();
      const isTableBottomHidden = tableClientRect.bottom > pageClientRect.bottom;

      // Show fixed pagination when scrolling up and table bottom is hidden or when the scroll is at the top
      const isPaginationFooterFixed = currentScrollTop < this.lastScrollPosition && isTableBottomHidden
        ? true
        : currentScrollTop > 0 ? false : isTableBottomHidden;

      // Put the table header in fixed position when it reached the top of the page when scrolling
      const isTableHeaderFixed = tableClientRect.top - pageClientRect.top < TABLE_TOP_MINIMUM_MARGIN;

      this.lastScrollPosition = currentScrollTop;
      this.updateFixedElementsWidth();

      if (isPaginationFooterFixed !== this.state.isPaginationFooterFixed || isTableHeaderFixed !== this.state.isTableHeaderFixed) {
        this.setState({ isPaginationFooterFixed, isTableHeaderFixed });
      }
    }
  }

  _initializeCurrentUserPermissions() {
    this._canUserAddIssue = null;
  }

  canUserAddIssue() {
    if (this._canUserAddIssue === null) {
      const { currentUser } = this.props;
      this._canUserAddIssue = canAdd(currentUser);
    }
    return this._canUserAddIssue;
  }


  changeIssueDetailsModalId(issueId) {
    const { changeLocationAction } = this.props;
    changeLocationAction(`/project/rfis/${issueId}`);
  }

  returnToListView() {
    const { changeLocationAction } = this.props;
    changeLocationAction('/project/rfis');
  }

  handlePageChange(pageLink) {
    const query = decodeURI(pageLink.substr(pageLink.indexOf('?') + 1));
    const queryObject = parseQueryString(query);
    const offset = lodashGet(queryObject, `page[${PAGE_PARAMS.OFFSET}]`, 0);
    this.props.setQueryParamsAction({ offset: parseInt(offset, 10) });
  }

  isFiltered(extractSearch = false) {
    const { queryParams } = this.props;
    const filterKeys = extractSearch ? objectValues(ISSUE_FILTER_PROPERTIES).filter(key => key !== ISSUE_FILTER_PROPERTIES.SEARCH) : objectValues(ISSUE_FILTER_PROPERTIES);
    const filters = pick(queryParams, filterKeys, []);
    // eslint-disable-next-line no-restricted-syntax
    for (const f in filters) {
      const filter = filters[f];
      if (filter && filter.length > 0) {
        return true;
      }
    }
    return false;
  }

  setIsFilterOpen(filtersOpen = !this.state.filtersOpen) {
    this.setState({ filtersOpen });
  }

  isEmptyState() {
    const { issues } = this.props;
    return !issues || issues.length === 0;
  }

  shouldShowProjectGridHeader() {
    return !this.props.error && (!this.isEmptyState() || this.isEmptyState() && this.isFiltered());
  }

  resetFilters() {
    this.props.setQueryParamsAction(preloadedFilterQueryParamsState[viewTypes.PROJECT]);
  }

  renderCreateBtn() {
    const { changeLocationAction } = this.props;

    return (
      <Button
        styleType={Button.StyleType.PRIMARY}
        className="ProjectGrid__create_button"
        data-testid="ProjectGrid__createButton"
        onClick={() => {
          changeLocationAction('/project/rfis/new');
        }}
        disabled={!this.canUserAddIssue()}
      >
        {T.translate('projectGrid.newBtn.title')}
      </Button>
    );
  }

  renderIssueNewModal() {
    const { showAddNewModal } = this.props;
    if (!showAddNewModal) {
      return null;
    }

    return (
      <IssueNewModal
        container={this}
        onClose={this.returnToListView}
      />
    );
  }

  renderIssuePreviewModal() {
    const { issueId, issuesSortOrder, issue } = this.props;
    const isModalOpen = !!issueId;

    return (
      <IssuePreviewModal
        container={this}
        issueId={issueId}
        issueStatus={issue.serverStatus}
        issuesSortOrder={issuesSortOrder}
        isModalOpen={isModalOpen}
        onClose={this.closePreviewModal}
        changePreviewId={this.changeIssueDetailsModalId}
      />
    );
  }

  renderExportPDFModal() {
    const { createReport, isCreatingPdfReport, queryParams } = this.props;

    const labelText = T.translate('rfis.label_capitalized');
    const textReport = T.translate('export.report');
    const textToday = toIsoDate(Date.now());

    return (
      <ExportPDFModal
        show={this.state.showExportPdfModal}
        container={this}
        title={`${labelText} ${textReport} ${textToday}`}
        onCreate={({ title, message }) => {
          const failureMessage = (
            <Text hasHTML>{T.translate('notifications.failedToProduce', { fileName: title })}</Text>
          );
          const payload = getRfiSummaryPayload({ title, message, queryParams });
          createReport(payload, undefined, failureMessage);
        }}
        onCancel={() => this.setState({ showExportPdfModal: false })}
        onExited={() => this.setState({ showExportPdfModal: false })}
        creating={isCreatingPdfReport}
      />
    );
  }

  renderCollectionPaginationFooter() {
    const paginationRawLinks = lodashGet(this.props, 'pagination.links');
    if (!paginationRawLinks) {
      return null;
    }

    const paginationRawMeta = lodashGet(this.props, 'pagination.meta', {});
    const paginationClassNames = cx({
      'ProjectGrid__pagination-footer-fixed': this.state.isPaginationFooterFixed,
    });

    const { first: firstLink, last: lastLink, prev: previousLink, next: nextLink } = paginationRawLinks;
    const paginationLinks = { firstLink, lastLink, previousLink, nextLink };
    const paginationMeta = {
      limit: paginationRawMeta.page.limit,
      offset: paginationRawMeta.page.offset,
      total: paginationRawMeta.recordCount,
    };

    return (
      <TablePagination className={paginationClassNames}
        onPageChange={this.handlePageChange}
        customPaginationDescription={T.translate('projectGrid.pagination.description')}
        paginationCounterSeparatorLabel={T.translate('projectGrid.pagination.separatorLabel')}
        {...paginationMeta}
        {...paginationLinks}
      />
    );
  }

  _renderEmptyStateDataDidntLoad() {
    return (
      <EmptyState
        icon={{
          svgId: 'cone',
          height: '120px',
          width: '120px',
        }}
        text={T.translate('projectGrid.emptyState.didntLoad')}
      />
    );
  }

  _renderEmptyStateNotFound() {
    return (
      <EmptyState
        icon={{
          svgId: 'not-found',
          height: '160px',
          width: '380px',
        }}
        text={T.translate('projectGrid.emptyState.notFound')}
      />
    );
  }

  _renderEmptyStateNoRows() {
    return (
      <EmptyState
        icon={{
          svgId: 'empty-box',
          height: '153px',
          width: '86px',
        }}
        text={T.translate('projectGrid.emptyState.noRows')}
        footer={this.renderCreateBtn()}
      />
    );
  }

  updateSearchExpression(searchExpression) {
    this.setState({ searchExpression });
  }

  showExportPdfModal() {
    this.setState({ showExportPdfModal: true });
  }

  renderTable() {
    const { issues, loading, error } = this.props;

    if (error) {
      return this._renderEmptyStateDataDidntLoad();
    }

    if (loading && !this.state.didFetchOnce) {
      return <Loader />;
    }

    // When we load issues collection after navigating to a new page via pagination we send resetCollection as true and it causes the isEmptyState to be true as well
    // Since we don't want to render empty state when we are in a middle of loading we added !loading to this if statement.
    if (!loading && this.isEmptyState()) {
      if (this.isFiltered()) {
        return this._renderEmptyStateNotFound();
      }
      return this._renderEmptyStateNoRows();
    }

    const tableContainerClassNames = cx('ProjectGrid__table-container', {
      'ProjectGrid__table-header-fixed': this.state.isTableHeaderFixed,
      'ProjectGrid__table-container--loading': loading,
    });

    return (
      <div className={tableContainerClassNames}>
        {this.state.isTableHeaderFixed ? <div className="ProjectGrid__opaque-separator" /> : null}
        <div ref={(node) => {
          this.tableElement = node;
        }}
        >
          <ProjectList issues={issues} />
        </div>
        {this.renderCollectionPaginationFooter()}
      </div>
    );
  }

  renderTableSection() {
    return (
      <DrawerWrapper isFiltered={this.isFiltered(true)} resetFilters={this.resetFilters} drawer={<Filter disabled={false} visible={true} displaySortDropdown={() => { }} displayFilterDropdown={() => { }} />} isOpen={this.state.filtersOpen} title={T.translate('projectGrid.filters.title')}
        onToggleDrawer={() => { this.setIsFilterOpen(false); }}
      >
        {this.renderTable()}
      </DrawerWrapper>
    );
  }

  render() {
    const { error, currentUser, history, issues, isCostEnabled, isMeetingEnabled } = this.props;
    const referencedByFF = featureFlags.get(FEATURE_FLAGS.RFIS_REFERENCED_BY);
    const rfi2pcoFF = featureFlags.get(FEATURE_FLAGS.RFIS_LINK_TO_PCO);
    const linkedEntitiesFF = referencedByFF || rfi2pcoFF;

    if (!currentUser || currentUser.loading) {
      return <Loader />;
    }

    const plugins = [
      isCostEnabled && rfi2pcoFF && pco,
      isMeetingEnabled && referencedByFF && meeting,
      referencedByFF && issue,
    ].filter(plugin => plugin);

    return (
      <MaintenanceMode>
      <LinkedEntitiesProviderFF issues={issues} linkedEntitiesFF={linkedEntitiesFF} plugins={plugins}>
        <div className="ProjectGrid" ref={node => {
          this.containerNode = node;
        }}
        >
          {this.shouldShowProjectGridHeader() &&
            <ProjectGridHeader
              searchExpression={this.state.searchExpression ? this.state.searchExpression : stripSearchQuery(this.props.queryParams[ISSUE_FILTER_PROPERTIES.SEARCH])}
              updateSearchExpression={this.updateSearchExpression}
              showExportPdfModal={this.showExportPdfModal}
              createBtn={this.renderCreateBtn()}
              filtersOpen={this.state.filtersOpen}
              isFiltered={this.isFiltered(true)}
              resetFilters={this.resetFilters}
              toggleFiltersOpen={this.setIsFilterOpen}
            />
          }

          <IssueFetchError error={error} />
          {this.renderTableSection()}
          {this.renderIssueNewModal()}
          {this.renderIssuePreviewModal()}
          {this.renderExportPDFModal()}
          <IFrameModal
            router={history}
            location={this.props.location}
            iframeSourceUrlParameter={POPUP_VIEWER_URL}
            iframeTitleUrlParameter={POPUP_VIEWER_TITLE}
          />
          <IssueAttachmentGallery container={this} />
          {featureFlags.get(FEATURE_FLAGS.PERMISSIONS_HANDLING) &&
            <NoPermissionsModal container={this} />}
        </div>
        </LinkedEntitiesProviderFF>
        </MaintenanceMode>
    );
  }
}

const mapStateToProps = (state) => ({
  issues: getIssueWrappersSorted(state),
  issue: getCurrentPreviewIssueAttributes(state),
  loading: getIssuesCollectionLoading(state),
  error: getIssuesCollectionError(state),
  pagination: getIssuesCollectionPagiantion(state),
  issueId: getCurrentPreviewIssueId(state),
  issuesSortOrder: getIssuesOrder(state),
  isCreatingPdfReport: getIsCreatingPdfReport(state),
  showAddNewModal: isShowNewIssueModal(state),
  currentUser: getCurrentUser(state),
  isVoidedFilterOn: isVoidedFilterOn(state),
  queryParams: getQueryParams(state),
  fetchParams: getFetchParams(state),
  isCostEnabled: isCostEnabled(state),
  isMeetingEnabled: isMeetingEnabled(state),
});

export default withRouter(connect(mapStateToProps, {
  changeLocationAction,
  setQueryParamsAction,
  fetchIssuesAction,
  removeIssueFromCollectionAction,
  trackEvent,
  createReport: ReportsThunk.createReport,
  setPreviewIssueIdAction,
})(PureProjectGrid));
